import React from 'react'
import { Route, Routes } from 'react-router-dom';
import Report from './Report';

export default function ReportRoute() {
  return (
       <Routes>
            <Route path="/" element={<Report />} />
       </Routes>
  )
}
